// extracted by mini-css-extract-plugin
module.exports = {"th-td":"Table_th-td__Yje8c"};